export default "__VITE_ASSET__BC8ih_Ha__"